import { ControlType, FieldBase, FieldBaseOptions } from './field-base';

export type TextboxType = 'text';

export interface TextBoxFieldOptions extends FieldBaseOptions {
  textboxType: TextboxType;
  prefix?: string;
  suffix?: string;
  displayOnly?: boolean;
}

export class TextboxField extends FieldBase<string> {
  readonly controlType: ControlType = 'textbox';
  textboxType: TextboxType;
  prefix: string;
  suffix: string;
  regexValidator: string;
  regexErrorMessage: string;
  displayOnly: boolean;

  constructor(options: TextBoxFieldOptions) {
    super(options);
    this.textboxType = options.textboxType || 'text';
    this.prefix = options.prefix || '';
    this.suffix = options.suffix || '';
    this.regexValidator = options.regexValidator || '';
    this.regexErrorMessage = options.regexErrorMessage || '';
    this.displayOnly = options.displayOnly || false;
  }
}
